export const shapes = [
  { value: { n: 4, values: [1, 2] }, label: "Ring" },
  { value: { n: 4, values: [3, 5] }, label: "Square" },
  { value: { n: 4, values: [6, 7] }, label: "Circle" },
  { value: { n: 4, values: [8] }, label: "Ethereum" },
  { value: { n: 4, values: [9] }, label: "Vertical Line" },
  { value: { n: 4, values: [10] }, label: "Horizontal Line" },
  { value: { n: 4, values: [11] }, label: "Vertical Triangles" },
  { value: { n: 4, values: [12] }, label: "Horizontal Triangles" },
  { value: { n: 4, values: [13] }, label: "Triangle" },
  { value: { n: 4, values: [14] }, label: "All Over" },
];

export const rectangles = [
  { value: { n: 3, values: [1, 2, 3, 4, 5] }, label: "125" },
  { value: { n: 3, values: [6, 7, 8, 9, 10] }, label: "250" },
  { value: { n: 3, values: [11, 12, 13 ,14] }, label: "500 + alpha" },
];

export const gradients = [
  { value: { n: 1, values: [1, 2] }, label: "None" },
  { value: { n: 1, values: [3, 4, 5, 6, 7] }, label: "Some" },
  { value: { n: 1, values: [8, 9, 10, 11, 12 ,13 ,14] }, label: "Full" },
];

export const rotations = [
  { value: { n: 5, values: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13 ,14] }, label: "No" },
  { value: { n: 5, values: [1, 2] }, label: "Yes" },
];

export const strokes = [
  { value: { n: 7, values: [1, 2, 3, 4] }, label: "No" },
  { value: { n: 7, values: [5, 6, 7, 8, 9, 10, 11, 12 ,13 ,14] }, label: "Yes" },
];

export const squares = [
  { value: { n: 8, values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] }, label: "No" },
  { value: { n: 8, values: [12, 13, 14] }, label: "Yes" },
];
